import { render, staticRenderFns } from "./rockiot.radial.svg.vue?vue&type=template&id=b083b216&"
import script from "./rockiot.radial.svg.vue?vue&type=script&lang=js&"
export * from "./rockiot.radial.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports